import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bc-economic-group',
  templateUrl: './bc-economic-group.component.html',
  styleUrls: ['./bc-economic-group.component.scss']
})
export class BcEconomicGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-economic-group/bc-economic-group.component.ts